export function isNumeric(item) {
  return !isNaN(item) ? item : false;
}
